"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertiserDimensions = exports.AdvertiserMetrics = void 0;
var AdvertiserMetrics;
(function (AdvertiserMetrics) {
    AdvertiserMetrics["METRIC_TYPE_IMPRESSION_COUNT"] = "METRIC_TYPE_IMPRESSION_COUNT";
    AdvertiserMetrics["METRIC_TYPE_GMV"] = "METRIC_TYPE_GMV";
    AdvertiserMetrics["METRIC_TYPE_ROI"] = "METRIC_TYPE_ROI";
    AdvertiserMetrics["METRIC_TYPE_ADD_TO_CART"] = "METRIC_TYPE_ADD_TO_CART";
    AdvertiserMetrics["METRIC_TYPE_BUDGET_BURNT"] = "METRIC_TYPE_BUDGET_BURNT";
})(AdvertiserMetrics || (exports.AdvertiserMetrics = AdvertiserMetrics = {}));
var AdvertiserDimensions;
(function (AdvertiserDimensions) {
    AdvertiserDimensions["DIMENSION_CAMPAIGN"] = "DIMENSION_CAMPAIGN";
    AdvertiserDimensions["DIMENSION_KEYWORD"] = "DIMENSION_KEYWORD";
    AdvertiserDimensions["DIMENSION_DAY"] = "DIMENSION_DAY";
    AdvertiserDimensions["DIMENSION_AD_CANDIDATE"] = "DIMENSION_AD_CANDIDATE";
    AdvertiserDimensions["DIMENSION_AD_LINKED_CATALOG_ID"] = "DIMENSION_AD_LINKED_CATALOG_ID";
})(AdvertiserDimensions || (exports.AdvertiserDimensions = AdvertiserDimensions = {}));
